<campaign-step-selector></campaign-step-selector>
@if (displayData$ | async; as data) {
  @if (data.stepType === stepTypes.CAMPAIGN_STEP_TYPE_EMAIL) {
    <div class="email-container">
      <glxy-email-viewer [html]="data.html"></glxy-email-viewer>
    </div>
  }
  @if (data.stepType === stepTypes.CAMPAIGN_STEP_TYPE_SMS) {
    <div class="sms-container">
      <glxy-chat-message>{{ data.html }}</glxy-chat-message>
    </div>
  }
} @else {
  <div class="empty-state">
    <glxy-empty-state [size]="'normal'">
      <p class="empty-state-text">Select campaign to view a preview</p>
    </glxy-empty-state>
  </div>
}
